import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  static values = { action: { type: String, default: "create" } }

  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly actionValue: string

  showLoading() {
    if (this.hasSubmitButtonTarget) {
      const originalText = this.submitButtonTarget.textContent || ""
      this.submitButtonTarget.dataset.originalText = originalText
      this.submitButtonTarget.disabled = true

      const loadingText = this.actionValue === "update" ? "Updating..." : "Creating..."
      this.submitButtonTarget.innerHTML = `
        <span class="loading loading-spinner loading-sm"></span>
        ${loadingText}
      `
    }
  }

  hideLoading(event: any) {
    if (this.hasSubmitButtonTarget) {
      const originalText = this.submitButtonTarget.dataset.originalText || "Submit"
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.innerHTML = originalText
    }

    // If update was successful and we're in update mode, close the modal
    if (this.actionValue === "update" && event?.detail?.success !== false) {
      // Check if there were no errors (successful submission)
      const form = this.element as HTMLFormElement
      const hasErrors = form.querySelector('.alert-error')

      if (!hasErrors) {
        const modal = document.getElementById('api_key_edit_modal') as HTMLDialogElement
        if (modal) {
          modal.close()
        }
      }
    }
  }
}
